import CustomButton from "components/CustomButton/CustomButton";
import LabelForm from "components/LabelForm/LabelForm";
import { Column, HelperText } from "components/styles";
import AvailableActivitiesFieldModal from "./AvailableActivitiesFieldModal";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import useCurrentSpaceTypeNameOfUniqueActivity from "../../utils/hooks/useCurrentSpaceTypeNameOfUniqueActivity";
import useUniversityActivityListSegmented from "./utils/hooks/useUniversityActivityListSegmented";

const AvailableActivitiesField = ({
	data: {
		spaceTypeList,
		universityActivityList
	}, form
}) => {
	const { spaceTypeId, availableActivityIds } = form.value;
	const dialog = useShowDialogAlert();
	const universityActivityListSegmented = useUniversityActivityListSegmented({
		universityActivityList
	});
	const currentSpaceTypeNameOfUniqueActivity = useCurrentSpaceTypeNameOfUniqueActivity({
		spaceTypeId: form.value.spaceTypeId, 
		spaceTypeList
	});
	return (
		<>
			<Column width="33.5%" gap="10px">
				<LabelForm
					text="Actividades disponibles"
					required={true} />
				<CustomButton
					variant="secondary"
					size="small"
					width="100%"
					text={availableActivityIds.length > 0 ? "Editar actividades" : "Seleccionar actividades"}
					onClick={dialog.open} 
					disabled={spaceTypeId === 0}/>
				{currentSpaceTypeNameOfUniqueActivity &&
				<HelperText>
					*Para "{currentSpaceTypeNameOfUniqueActivity}" es una única actividad
				</HelperText>}
			</Column>
			<AvailableActivitiesFieldModal
				dialog={dialog} 
				universityActivityListSegmented={universityActivityListSegmented}
				form={form}/>
		</>
	);
}

export default AvailableActivitiesField;